import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=390bb2d0&scoped=true&"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNotes.vue?vue&type=style&index=0&id=390bb2d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390bb2d0",
  null
  
)

export default component.exports